import {forwardRef} from "react";
import {Paper, type PaperProps} from "@mui/material";

export const CustomPaper = forwardRef(function CustomPaper(
    {sx, children, ...props}: PaperProps,
    ref,
) {
    return (
        <Paper
            ref={ref}
            component="div"
            elevation={1}
            sx={{
                borderRadius: "8px",
                background: "var(--Schemes-Surface, #F9F9FF)",
                boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.12)",
                p: 2,
                ...sx,
            }}
            {...props}
        >
            {children}
        </Paper>
    );
});

